 <template>
    <el-dialog :visible.sync="visible" width="600px" append-to-body title="编辑线索" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">
        <el-form :model="form" size="mini" label-position="top" v-loading="loading">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="线索名称" :rules="[{ required: true, message: '必填项' }]" :error="formError.name?.toString()" prop="name">
                        <el-input v-model="form.name" placeholder="请填写线索名称" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="线索来源">
                        <crm-leads-source-select v-model="form.source_id" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="手机">
                        <el-input v-model="form.phone" placeholder="请填写工作电话" prefix-icon="el-icon-mobile" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="负责人" :rules="[{ required: true, message: '必填项' }]" :error="formError.user_admin_id?.toString()" prop="user_admin_id">
                        <users-select v-model="form.user_admin_id" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="电话">
                        <el-input v-model="form.phone_t" placeholder="请填写联系人工作电话" prefix-icon="el-icon-phone-outline" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮箱">
                        <el-input v-model="form.email" placeholder="电子邮件地址" prefix-icon="el-icon-message" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="客户级别">
                        <crm-customer-level-select v-model="form.level_id" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客户行业">
                        <crm-customer-type-select v-model="form.type_id" />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="地址">
                        <config-country-cascader v-model="form.country_id" margin="0 0 5px 0" />
                        <el-input type="textarea" :rows="2" v-model="form.address" placeholder="详细地址" clearable />
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="备注">
                        <el-input type="textarea" :rows="2" v-model="form.remark" placeholder="备注" clearable />
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer">
            <el-button size="mini" @click="Close()">取 消</el-button>
            <el-button size="mini" type="primary" @click="SubmitForm()" :loading="loading">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data () {
        return {
                        visible: false,
            loading: false,
            formError: {},
            form: {
                id: null,
                name: null,
                source_id: null,
                user_admin_id: this.$store.state.user.id,
                customer_id: null,
                phone: null,
                phone_t: null,
                email: null,
                level_id: null,
                type_id: null,
                country_id: null,
                address: null,
                remark: null
            }
        }
    },
    methods: {
        Open (id) {
            this.visible = true
            this.loading = true
            this.$http.post('/9api/crm/leads/search-first', { search: { id: id } }).then(rps => {
                this.form = rps.data
                this.loading = false
            })
        },
        Close() {
            this.loading = false
            this.visible = false
        },
        SubmitForm() {
                        this.loading = true
            this.formError = {}
                        this.$http.post('/9api/crm/leads/update', this.form).then(rps => {
                                this.loading = false
                                if (rps.data.state == 'error') {
                    this.formError = rps.data.body
                }
                                if (rps.data.state == 'success') {
                    this.$emit('onChange', rps.data.body)
                    this.Close()
                }
            })
        }
    }  
}
</script>